var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"17","height":"13","viewBox":"0 0 17 13","fill":"#2F2F2F","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.697 2.197V.53H.031v1.667h16.666zm0 3.333v1.667H.031V5.53h16.666zm0 5v1.667H.031V10.53h16.666z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }